'use strict'

export default {

}
